import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ReportItemPaper from "./ReportItemPaper";
import ReportItemGrid, { gridPlaceHolder } from "./ReportItemGrid";

import { withStyles, Typography, Button } from '@material-ui/core';

const styles = theme => ({
	noData: {
		marginTop: "25%",
		textAlign: "center"
	},

	cardWrapper: {
		//borderRadius: 16,
		//border: `0.5px solid ${theme.palette.primary.lightGrey}`
	}
});

class ReportItemGridWrapper extends Component {
	render() {
		let {classes, items, fidoError, title, subtitle, taller, itemClickPath, history,
			contentRenderer, buttonClickHandler, buttonText, noDataMessage, className, buttonClassName} = this.props;

		return (
			<ReportItemPaper
				ready={items != null}
				fidoError={fidoError}
				placeHolder={gridPlaceHolder}
				title={title}
				subtitle={subtitle}
				taller={taller}
				className={classes.cardWrapper}
				buttons={items && items.length ?
						<div>
							{buttonClickHandler ?
								<Button
									size="small"
									color="primary"
									className={`${buttonClassName}`}
									onClick={buttonClickHandler}>{buttonText}</Button> : null
							}
						</div>
					: null
				}>
				{items && items.length ?
					<div>
						<ReportItemGrid
							items={items}
							history={history}
							itemClickPath={itemClickPath}
							contentRenderer={contentRenderer} />
					</div>
					:
					<Typography color="textSecondary" className={classes.noData}>
						{noDataMessage}
					</Typography>
				}
			</ReportItemPaper>
		);
	}
}

ReportItemGridWrapper.propTypes = {
	classes: PropTypes.object.isRequired,
	contentRenderer: PropTypes.func.isRequired,
	history: PropTypes.object.isRequired,
	title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	subtitle: PropTypes.string,
	taller: PropTypes.bool,
	itemClickPath: PropTypes.string,
	buttonClickHandler: PropTypes.func,
	buttonText: PropTypes.string,
	noDataMessage: PropTypes.string,
	items: PropTypes.array,
	fidoError: PropTypes.bool,
	buttonClassName: PropTypes.string
};

export default withStyles(styles)(ReportItemGridWrapper);
